import { screenSizes } from './screenSizes';
var media = {
    up: function (breakpoint) {
        return "@media screen and (min-width: ".concat(screenSizes[breakpoint].min, "px)");
    },
    down: function (breakpoint) {
        return "@media screen and (max-width: ".concat(screenSizes[breakpoint].max, "px)");
    },
    between: function (minScreenSize, maxScreenSize) {
        var minWidth = "min-width: ".concat(screenSizes[minScreenSize].min, "px");
        var maxWidth = "max-width: ".concat(screenSizes[maxScreenSize].max, "px");
        return "@media screen and (".concat(minWidth, ") and (").concat(maxWidth, ")");
    },
};
export { media };
//# sourceMappingURL=media.js.map